import React from 'react';
import { useRegion } from '@/contexts/RegionContext';

interface RegionGateProps {
  allowedRegions: string[];
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/**
 * A wrapper component that only renders its children if the user is in one of the allowed regions.
 * Example: <RegionGate allowedRegions={['us', 'ca']}> ... </RegionGate>
 */
export function RegionGate({ allowedRegions, children, fallback = null }: RegionGateProps) {
  const { regionCode, loading } = useRegion();

  if (loading) {
    return null; // Or a loading spinner if preferred
  }

  // If "all" is in the allowed list, or if the current region matches, render children
  if (allowedRegions.includes('all') || allowedRegions.includes(regionCode)) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
}
